import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Card = (props) => {
    const { className, ...otherProps } = props;
    return <div {...otherProps} className={clsx("card", className)} />;
};
Card.propTypes = {
    className: PropTypes.string,
};

export default Card;
